"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nInit = void 0;
/* eslint-disable no-unused-vars */
const i18next_1 = __importDefault(require("i18next"));
exports.i18nInit = i18next_1.default;
const i18n_json_1 = __importDefault(require("./translations/en/i18n.json"));
const i18n_json_2 = __importDefault(require("./translations/pl/i18n.json"));
const pl_1 = __importDefault(require("date-fns/locale/pl"));
const en_US_1 = __importDefault(require("date-fns/locale/en-US"));
const react_datepicker_1 = require("react-datepicker");
const react_native_1 = require("react-native");
let language = navigator.language;
(0, react_datepicker_1.registerLocale)('pl', pl_1.default);
(0, react_datepicker_1.registerLocale)('en', en_US_1.default);
if (!language) {
    const deviceLanguage = react_native_1.Platform.OS === 'ios'
        ? react_native_1.NativeModules.SettingsManager.settings.AppleLocale ||
            react_native_1.NativeModules.SettingsManager.settings.AppleLanguages[0] //iOS 13
        : react_native_1.NativeModules.I18nManager.localeIdentifier;
    language = deviceLanguage.slice(0, 2);
}
const i18nInit = i18next_1.default.init({
    compatibilityJSON: 'v3',
    interpolation: { escapeValue: false },
    lng: language,
    resources: {
        en: {
            i18n: i18n_json_1.default
        },
        pl: {
            i18n: i18n_json_2.default
        }
    }
});
